import styled from "styled-components";
import { Flex } from "antd";

const StylesContainer = styled(Flex)`
  background: ${({ token }) => token.background_primary};
  background-size: cover;
  box-sizing: border-box;
  color: #fff;
  height: 100vh;
  overflow: auto;

  header {
    width: 100%;

    article {
      align-items: center;
      color: #fff;
      display: flex;
      font-size: 18px;
      justify-content: space-between;
      padding: 16px 32px;

      h4 {
        margin: unset;
      }
    }

    .ant-breadcrumb-link.active {
      color: #fff;
    }

    .ant-breadcrumb .ant-breadcrumb-separator {
      color: #a5a3a3;
    }

    .ant-btn-circle {
      background: rgba(218, 226, 229, 0.6);
      height: 32px;
      width: 32px;
    }
  }

  main {
    backdrop-filter: blur(6px);
    background: ${({ token }) => token.proposal_quiz__form_background};
    border-radius: 12px;
    border-top: 1px solid rgba(255, 255, 255, 0.4);
    box-shadow:
      0 4px 4px 0 rgba(0, 0, 0, 0.25),
      0 8px 20px 0 rgba(0, 0, 0, 0.54);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    margin: 91px 12px 24px;
    max-width: 671px;
    padding: 40px;
    width: 100%;

    h2 {
      color: #fff;
      font-size: 32px;
      font-weight: 700;
      line-height: 130%;
      letter-spacing: -0.64px;
      margin: unset;
    }

    p {
      color: #fff;
      font-size: 16px;
      line-height: 160%;
      letter-spacing: -0.32px;
      margin: unset;
    }

    .ant-input-number {
      width: 100%;
    }

    .ant-form-item .ant-form-item-label > label {
      color: #fff;
    }

    .ant-input-number-group-addon {
      background: #fff;
    }

    .ant-radio-wrapper {
      width: 277px;

      span.ant-radio + * {
        color: #fff;
        font-size: 26px;
        font-weight: 400;
        opacity: 0.7;
        padding-left: 16px;

        &:hover {
          opacity: 1;
        }
      }

      .ant-radio-inner {
        width: 30px;
        height: 30px;
      }

      color: #fff;
      font-weight: 700;

      .ant-radio-checked {
        &.ant-radio + * {
          opacity: 1;
          font-weight: 700;
        }

        .ant-radio-inner {
          background: #fff;
          border-color: #fff;
        }

        .ant-radio-inner::after {
          background: #c0e2f0;
          transform: scale(0.75);
        }
      }
    }
  }

  footer {
    display: flex;
    gap: 10px;
    justify-content: end;

    .ant-btn-circle {
      background: #84b8c8;
      color: #fff;
      height: 32px;
      width: 32px;

      &:disabled {
        opacity: 0.2;
      }
    }
  }

  @media screen and (max-width: ${({ token }) => token.screenMDMax}px) {
    height: 100vh;
    overflow: auto;

    header {
      padding-bottom: 16px;

      .logo {
        height: 38px;
        width: 123px;
      }
    }
  }
`;

export default StylesContainer;
